import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

const STAGE_CATEGORY_CONFIG = {
    level1: {
        name: 'firstStageCategories',
        placeholder: '1st stage category',
    },
    level2: {
        name: 'secondStageCategories',
        placeholder: '2nd stage category',
    },
};

export const StageCategoryFilter = ({
    level,
    options,
    loading,
    filters,
    restoreFilterValues,
    hidden,
    onChangeValue,
}) => {
    const config = STAGE_CATEGORY_CONFIG[level];

    return (
        <Field
            component={Form.ReduxSelect}
            name={config.name}
            options={options}
            disabled={loading}
            setValue={restoreFilterValues(filters, config.name) ?? ''}
            placeholder={config.placeholder}
            loading={loading}
            className='long'
            hidden={hidden}
            search
            multiple
            selection
            onChangeValue={onChangeValue}
        />
    );
};

StageCategoryFilter.propTypes = {
    level: PropTypes.oneOf(['level1', 'level2']).isRequired,
    options: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    hidden: PropTypes.bool,
    onChangeValue: PropTypes.func,
};

